import { Component, Input, OnInit } from '@angular/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import {
  Utility,
  convertParseDateTime,
  convertParseDateTimeLangSpecific,
  extractDateTimeFromDateString,
} from 'src/app/shared/utils/utility.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import {
  IActiveIssuesDashboard,
} from '../activity/user-card.interface';
import { DashboardManagementService } from 'src/app/dashboard/dashboard-management.service';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { enUS, fr } from 'date-fns/locale';

@Component({
  selector: 'app-dashboard-device-card',
  templateUrl: './dashboard-device-card.component.html',
  styleUrls: ['./dashboard-device-card.component.scss'],
})
export class DashboardDeviceCardComponent implements OnInit {
  readonly LANG_CONST = LANG_CONST;
  readonly CONSTANTS = CONSTANTS;
  commonAccessControl!: boolean;
  sharedData!: ISharedData;
  locale = this.stateManagementService.getUserLanguage();

  @Input() activeIssues!: IActiveIssuesDashboard;
  constructor(public dashboardManagementService: DashboardManagementService,
    private stateManagementService: StateManagementService) {}

  ngOnInit(): void {
   this.commonAccessControl = this.stateManagementService.getSharedData()?.selectedSite?.commonAccessControl; 
  }

  getContentFormatDate(time: string, format: 'hh:mma') {
    const lang = this.locale === LANG_CONST.FRENCH ? fr : enUS;
    return convertParseDateTimeLangSpecific(
      extractDateTimeFromDateString(String(time)),
      "yyyy-MM-dd'T'HH:mm:ss",
      format,
      lang
    );
  }

  /**
   *
   * @param data string content
   * @returns enccode string into base64
   */
  encode(data: string): string {
    return Utility.encodeToBase64(data);
  }

  /**
   * @returns navigate to unit detail page
   * @void {srting}
   */
  navigateToUnitDetail(activeIssue: any): any[] {
    return [
      'active-issues',
      'unit',
      this.encode(activeIssue?.id),
      this.encode(activeIssue?.buildingId),
      this.encode(activeIssue?.unitId),
      this.encode(activeIssue?.buildingName),
      this.encode(activeIssue?.floorId),
    ];
  }

  /**
   * @returns navigate to access point detail page
   * @void {srting}
   */
  navigateToAccessPointDetail(activeIssue: any): any[] {
    return [
      'active-issues',
      'accesspoint',
      this.encode(activeIssue.id),
      this.encode(activeIssue.buildingId),
      this.encode(activeIssue.accessPointId),
      this.encode(activeIssue.buildingName),
      this.encode(activeIssue.floorId),
    ];
  }
}
